module.exports = __webpack_public_path__ + "img/bg-landing-4.44b46a96.jpg";